<template>
  <canvas :id="options.elm" ref="canvasRef"></canvas>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const MI = 1609.344;
const FT = 3.28084;

const props = defineProps({
  chartdata: {
    type: [Object, Array],
    required: true,
  },
  options: {
    type: Object,
    required: true,
  },
  challenge: {
    type: Object,
    required: true,
  },
  width: {
    type: Number,
    default: 200,
  },
  height: {
    type: Number,
    default: 200,
  },
  textColor: {
    type: String,
    default: '#fff',
  },
  strokeColor: {
    type: String,
    default: '#fff',
  },
  fullWidth: {
    type: Boolean,
    default: false,
  },
});

const canvasRef = ref(null);
const currentProgress = ref(0);

onMounted(() => {
  let totalMi = 0;
  let totalEl = 0;
  let totalTi = 0;

  // Calculate totals from chartdata
  for (const key in props.chartdata) {
    totalMi += parseFloat(props.chartdata[key].distance);
    totalTi += parseFloat(props.chartdata[key].moving_time);
    if (props.chartdata[key].elevation_gain !== '') {
      totalEl += parseFloat(props.chartdata[key].elevation_gain);
    }
  }

  totalMi = totalMi / MI;
  totalEl = totalEl * FT;
  totalTi = totalTi / 60;

  // Calculate progress based on challenge type
  switch (props.challenge.challenge_type) {
  case 'distance':
    currentProgress.value = (totalMi / props.challenge.target) * 100;
    break;
  case 'elevation':
    currentProgress.value = (totalEl / props.challenge.target) * 100;
    break;
  case 'time':
    currentProgress.value = (totalTi / props.challenge.target) * 100;
    break;
  }

  // Canvas drawing
  const ctx = canvasRef.value.getContext('2d');
  ctx.canvas.width = props.width;
  ctx.canvas.height = props.height;

  const cw = ctx.canvas.width;
  const ch = ctx.canvas.height;
  const radius = props.fullWidth ? cw * 0.375 : 75;
  const start = 4.72;

  ctx.fillStyle = props.textColor;
  ctx.strokeStyle = props.strokeColor;
  ctx.textAlign = 'center';
  ctx.font = '600 36px Inter';

  const percText = props.chartdata === 0 ? props.chartdata + '%' : props.chartdata;
  const compText = 'COMPLETE';

  let al = 0;

  if (currentProgress.value === 0) {
    // Static display for zero progress
    ctx.font = '600 36px Inter';
    ctx.fillText(percText, cw * 0.52, ch * 0.5 + 5, cw + 12);
    ctx.font = '600 15px Inter';
    ctx.fillText(compText, cw * 0.52, ch * 0.5 + 25, cw + 12);
  } else {
    // Animated progress
    const animate = () => {
      const diff = ((al / 100) * Math.PI * 2 * 10).toFixed(2);
      ctx.clearRect(0, 0, cw, ch);
      ctx.lineWidth = 20;
      ctx.lineCap = 'round';
      ctx.fillStyle = props.textColor;
      ctx.strokeStyle = props.strokeColor;
      ctx.textAlign = 'center';
      ctx.font = '600 36px Inter';
      ctx.fillText(al + '%', cw * 0.52, ch * 0.5 + 5, cw + 12);
      ctx.font = '600 15px Inter';
      ctx.fillText('COMPLETE', cw * 0.52, ch * 0.5 + 25, cw + 12);
      ctx.beginPath();
      ctx.arc(cw / 2, ch / 2, radius, start, diff / 10 + start, false);
      ctx.stroke();

      if (al < currentProgress.value) {
        al++;
        setTimeout(animate, 10);
      }
    };
    animate();
  }
});
</script>
